import { render } from "./Achievements.vue?vue&type=template&id=130ddbeb&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"

import "./Achievements.vue?vue&type=style&index=0&id=130ddbeb&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src1692007530/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ddbeb"]])

export default __exports__